import { Typography } from "@material-ui/core"
import {
  selectedDetailingSelector,
  selectedEngineSelector,
} from "components/shopFeatures/detailing/detailingSelectors"
import { Font } from "components/shopFeatures/wizard/constants"
import { useTypedSelector } from "store"
import styled, { css } from "styled-components"

type PopupProps = {
  popup?: boolean
}

const StyledIfPopup = styled.div<{ popup?: boolean }>`
  ${(p) =>
    p.popup &&
    css`
      ${StyledHeadline} {
        ${(p) => p.theme.breakpoints.up("md")} {
          margin-top: ${(p) => p.theme.spacing(1.5)}px;
        }
      }

      ${StyledDetailing} {
        font-size: 1rem;
        margin-top: ${(p) => p.theme.spacing(1.5)}px;

        ${(p) => p.theme.breakpoints.up("md")} {
          margin-top: ${(p) => p.theme.spacing(1.5)}px;
        }
      }
    `}
  margin-bottom: -70px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-bottom: -100px;
  }
`

const StyledHeadline = styled(Typography).attrs({
  variant: "h1",
  component: "div",
})`
  margin: ${(p) => p.theme.spacing(2, 0)};
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: normal;
  flex-shrink: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: ${(p) => p.theme.spacing(3.5)}px;
  }
`
const StyledModel = styled(Typography).attrs({
  variant: "h2",
  component: "h1",
})`
  font-size: 1.3125rem;
  letter-spacing: 2.1px;
  margin: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    font-family: ${Font.MazdaType};
    font-size: 32px;
    font-weight: 500;
    line-height: 45px;
    letter-spacing: 0.11em;
  }
`
const StyledDetailing = styled(Typography).attrs({ variant: "h2" })`
  font-family: ${Font.MazdaType};
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.08em;
  color: ${(p) => p?.theme?.colors?.disable};

  margin-top: ${(p) => p.theme.spacing(0.5)}px;

  ${(p) => p.theme.breakpoints.up("md")} {
    margin-top: ${(p) => p.theme.spacing(1)}px;
  }
`

const ModelAndDetailing = ({ popup }: PopupProps) => {
  const selectedDetailing = useTypedSelector(selectedDetailingSelector)
  const selectedEngine = useTypedSelector(selectedEngineSelector)

  if (!selectedDetailing) return null

  const { modelName, name } = selectedDetailing.details

  return (
    <StyledIfPopup popup={popup}>
      <StyledHeadline>
        <StyledModel>{modelName.toUpperCase()}</StyledModel>
        <StyledDetailing>
          {name} {selectedEngine?.engineIdName}
        </StyledDetailing>
      </StyledHeadline>
    </StyledIfPopup>
  )
}

export default ModelAndDetailing
